import { render, staticRenderFns } from "./CommunitySocialShare.vue?vue&type=template&id=fbb6ad2a&"
import script from "./CommunitySocialShare.vue?vue&type=script&lang=ts&"
export * from "./CommunitySocialShare.vue?vue&type=script&lang=ts&"
import style0 from "./CommunitySocialShare.vue?vue&type=style&index=0&id=fbb6ad2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports